<template>
    <article class="tile-small flex h-full flex-col gap-4 bg-white">
        <img
            class="bg-blue-heavy/25 h-31.5 rounded object-cover lg:h-45"
            :src="image?.url + '?width=579&format=webp'"
            :alt="image?.alt ?? 'Blog image'"
            :title="image?.title ?? 'Blog image'" />
        <header class="flex flex-col gap-2">
            <h3 v-show="title" class="font-title order-2 line-clamp-2 text-lg">{{ title }}</h3>
            <h4 v-if="pageType" class="font-body order-1 text-sm">{{ pageType }}</h4>
        </header>
        <p class="line-clamp-3">
            {{ excerpt }}
        </p>
        <footer class="mt-auto">
            <NuxtLink :to="localeRoute(url ?? '/')" class="btn-tertiary-a inline-button">{{
                $t('common.readMore')
            }}</NuxtLink>
        </footer>
    </article>
</template>

<script setup lang="ts">
import type { BlogItemModel } from '@su4r-frontend/api';

const localeRoute = useLocaleRoute();

defineProps<BlogItemModel>();
</script>
